import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, Divider } from "antd";
import { UserOutlined, LockOutlined, CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./Login.scss";
import config from "../../config.json";
import React, { useEffect, useState } from "react";
import i18n from "i18next";
import LoginCard from "./LoginCard";
import {useAuth} from "./AuthProvider";
import {useNotification} from "../../Helper/NotificationProvider";
import { URL_AUTH} from "../../service/endpoints";
import { postData } from '../../service/APIClient';
import { getBlobUrl } from '../../Helper/helperFunctions';

export default function LoginPage(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const { login } = useAuth();
  const { openNotification, contextHolder } = useNotification();
  const [logoUrl, setLogoUrl] = useState(config.logo);

  // Fetch fresh logo URL on mount
  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (config.login.imageBlobId) {
        const url = await getBlobUrl(config.login.imageBlobId);
        if (url) setLogoUrl(url);
      }
    };
    fetchLogoUrl();
  }, []);

  const handleClose = () => {
    navigate("/");
  };

  const onFinish = (values) => {
    postAuthentication(values.username, values.password);
  };

  const postAuthentication = async (user, password) => {
    try {
      if (user !== "" && password !== "") {
        const authBody = {
          email: user,
          password: password,
        };


        const response = await postData(URL_AUTH, authBody)
        const { userId, permissionLevel, accessToken, refreshToken, tenantId } = response;
        login(userId, permissionLevel, accessToken, refreshToken, tenantId);
        navigate("/");
      }
    } catch (err) {
      openNotification(
        "bottomRight",
        "Fehler",
        "Login fehlgeschlagen, bitter erneut versuchen.",
        false
      );
      console.log(err);
    }
  };

  return (
    <div className="container">
      {contextHolder}
      <header className="app-header">
        <img src={logoUrl} alt="Logo" />
        {!config.login.active && (
          <div className="close-btn">
            <Button
              shape="circle"
              type="primary"
              onClick={handleClose}
              icon={<CloseOutlined />}
              size={"large"}
              className="close-login-btn"
            />
          </div>
        )}
      </header>
      <div className="card-login">
        <p className="title">{config.login.title}</p>
          <LoginCard
            translation={t}
            setLanguage={setLanguage}
            onFinish={onFinish}
            language={language}
          />
      </div>
      {/*<BaseFooter />*/}
    </div>
  );
}
